import { MutationTree } from 'vuex'
import { Filter, ScheduleState } from './types'
import {
  DoctorModuleItem,
  PendingConsultationItem
} from '@/store/consultories/types'

export enum ScheduleMutations {
  SET_FILTER_OPEN = 'SET_FILTER_OPEN',
  SHOW_WITH_FILTER = 'SHOW_WITH_FILTER',
  SHOW_REQUESTS = 'SHOW_REQUESTS',
  SET_LOADER_DOCTOR_MODULES = 'SET_LOADER_DOCTOR_MODULES',
  SET_ALL_DOCTOR_MODULES = 'SET_ALL_DOCTOR_MODULES',
  SET_PENDING_CONSULTATIONS = 'SET_PENDING_CONSULTATIONS',
  SET_SCHEDULED_CONSULTATIONS = 'SET_SCHEDULED_CONSULTATIONS',
  SET_LOADER_PENDING_CONSULTATIONS = 'SET_LOADER_PENDING_CONSULTATIONS',
  SET_LOADER_SCHEDULED_CONSULTATIONS = 'SET_LOADER_SCHEDULED_CONSULTATIONS',
  SET_LOADER_CANCEL_CONSULTATIONS = 'SET_LOADER_CANCEL_CONSULTATIONS'
}

export const mutations: MutationTree<ScheduleState> = {
  [ScheduleMutations.SET_FILTER_OPEN](state: ScheduleState, payload: boolean) {
    state.filterOpen = payload
  },

  [ScheduleMutations.SHOW_WITH_FILTER](state: ScheduleState, payload: Filter) {
    state.filter = payload
  },

  [ScheduleMutations.SHOW_REQUESTS](state: ScheduleState, payload: boolean) {
    state.showRequests = payload
  },

  [ScheduleMutations.SET_LOADER_DOCTOR_MODULES](
    state: ScheduleState,
    payload: boolean
  ) {
    state.loadingAllModules = payload
  },

  [ScheduleMutations.SET_ALL_DOCTOR_MODULES](
    state: ScheduleState,
    events: Array<DoctorModuleItem>
  ) {
    state.doctorModules = events
  },

  [ScheduleMutations.SET_PENDING_CONSULTATIONS](
    state: ScheduleState,
    events: Array<PendingConsultationItem>
  ) {
    state.pendingConsultations = events
  },

  [ScheduleMutations.SET_SCHEDULED_CONSULTATIONS](
    state: ScheduleState,
    events: Array<PendingConsultationItem>
  ) {
    state.scheduledConsultations = events
  },

  [ScheduleMutations.SET_LOADER_PENDING_CONSULTATIONS](
    state: ScheduleState,
    payload: boolean
  ) {
    state.loadingPendingConsultations = payload
  },

  [ScheduleMutations.SET_LOADER_SCHEDULED_CONSULTATIONS](
    state: ScheduleState,
    payload: boolean
  ) {
    state.loadingScheduledConsultations = payload
  },

  [ScheduleMutations.SET_LOADER_CANCEL_CONSULTATIONS](
    state: ScheduleState,
    payload: boolean
  ) {
    state.loadingCancelConsultations = payload
  }
}
